import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
	name: '',
	//进入的是什么管理系统
	data() {
		return {
			// 表格数据
			studnetData: [],
			// 总条数
			studentTotal: 0,
			// 修改弹窗
			dialogFormVisible: false,
			time: '',
			//修改弹窗信息
			form: {
				user_name: "",
				idcard: "",
				comment: "",
				package_name: "",
				private: "",
				progress: "",
				rate: ""
			},
			id: '',
			// 表格数据起始位置
			studentCurrentPage: 0,
			// pagesize: 15,
			pageLen: 30,
			// 当前页数
			currentPage: 1,
			// loading状态
			fullscreenLoading: false,
			//表单的样式宽度
			formLabelWidth: "200px",
			// 卡片数据
			forms: {
				name: "",
				idcard: "",
				product_name: "",
				package_name: "",
			},
			top: 'top',
			// 评分规则
			proportion: '',
			tableType: true,
			// 评分规则数组
			proportionList: [],
			// 地区选项
			options: [{
					value: '廉江',
					label: '廉江'
				},
				{
					value: '台山',
					label: '台山'
				}
			],
			// 选择的地区
			region: '',
			// 进度选择
			options2: [{
					value: '1',
					label: '已完成',
					key: 1,
				},
				{
					value: '0',
					label: '未开始、未完成',
					key: 2
				}
			],
			// 选择的进度
			progress: '',
		}
	},
	methods: {
		//调整为详细表
		detailedTable() {
			this.tableType = true
			this.currentPage = 1;
			this.getArrlist()
		},
		//调整为简表
		summaryTable() {
			this.tableType = false
			this.currentPage = 1;
			this.getArrlist()
		},
		serchTable() {
			this.getArrlist()
		},
		// 导出excel
		exportExcel() {
			let wb = XLSX.utils.table_to_book(document.getElementById('exportXlsx'), {
				raw: true
			})

			let wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			})
			try {
				FileSaver.saveAs(new Blob([wbout], {
					type: 'application/octet-stream'
				}), 'test.xlsx')
			} catch (e) {
				if (typeof console !== 'undefined') console.log(e, wbout)
			}
			return wbout
		},
		Search() {
			// console.log(this.forms.name);
			this.currentPage = 1;
			this.studentCurrentPage = 0;
			let data = {
				token: this.$store.state.authority_management,
				offset: this.studentCurrentPage,
				length: this.pageLen,
				shop_id: this.$store.state.store.id
			}
			this.$post('purchased/get_progress', data).then(res => {
				this.studentTotal = res.data.result.total;
				this.studnetData = res.data.result.data;
				// console.log(this.studnetData);

			})
			// this.getdata();
		},
		// 修改
		updateStuInfo(row) {
			this.dialogFormVisible = true;
			this.form = row;
			// console.log(this.form);
		},
		//修改
		edit() {
			this.dialogFormVisible = false;
			let data = {};
			this.$post().then(res => {
				// // console.log(res);
				if (res.data.status == 'success') {
					this.dialogUpdatetVisible = false;
					this.$message({
						showClose: true,
						message: '修改成功',
						type: 'success'
					});
					this.getdata();
				} else {
					this.$message({
						showClose: true,
						message: '修改失败',
						type: 'error'
					});
				}
			})
		},
		gettime() {
			if (this.form.rate) {
				return (JSON.parse(this.form.rate))[0].start_date_time;
			} else {
				return null;
			}

		},
		gettime2() {
			if (this.form.rate) {
				return (JSON.parse(this.form.rate))[0].end_date_time;
			} else {
				return null;
			}

		},
		//获取表格数据
		getdata() {
			// this.fullscreenLoading = true
			// this.searchType = true;
			this.$post('purchased/get_progress', {
				token: this.$store.state.id,
				offset: this.studentCurrentPage,
				length: this.pageLen,
				shop_id: this.$store.state.store.id
			}).then(res => {
				this.studentTotal = res.data.result.total;
				this.studnetData = res.data.result.data;
				// console.log((JSON.parse(this.studnetData[3].rate))[0]);

			})
		},
		getrate(id) {
			if (JSON.parse(this.studnetData[id].rate))
				return (JSON.parse(this.studnetData[id].rate)[0].start_date_time);
			else {
				return null;
			}
		},
		getrate2(id) {
			if (JSON.parse(this.studnetData[id].rate))
				return (JSON.parse(this.studnetData[id].rate)[0].end_date_time);
			else {
				return null;
			}
		},
		//分页页数变动事件
		getStudentPage(currentPage) {
			this.currentPage = currentPage;
			this.studentCurrentPage = (Number.parseInt(currentPage) - 1) * this.pageLen / 3;
			this.getArrlist()
		},
		//页面条数变动事件
		handleSizeChange(val) {
			this.pageLen = val;
			this.getArrlist();
		},

		//获取数组处理数据并计算分数
		getArrlist() {

			this.fullscreenLoading = true

			let requestUrl = ''
			// 根据需要查询的进度调用不同的接口
			if (this.$isAbnormal(this.progress) || this.progress == 1) {
				requestUrl = 'purchased/get_purchased_detail'
			} else {
				// 查询进度小于1的接口
				this.progress = 1
				requestUrl = 'purchased/get_purchased_detail_lt'
			}

			this.studnetData = []
			let getArrData = {}
			if (this.tableType) {
				getArrData = {
					company: this.forms.package_name,
					token: this.$store.state.authority_management,
					offset: (this.currentPage - 1) * this.pageLen,
					length: this.pageLen,
					progress: this.progress,
					product_name: this.forms.product_name,
					shop_id: this.$store.state.store.id
				}
			} else {
				getArrData = {
					company: this.forms.package_name,
					token: this.$store.state.authority_management,
					offset: (this.currentPage - 1) * this.pageLen,
					length: this.pageLen,
					progress: this.progress,
					product_name: this.forms.product_name,
					shop_id: this.$store.state.store.id
				}
			}
			this.progress = ''
			this.$post(requestUrl, getArrData).then(res => {
				let allData = res.data.result.data
				let listData = []
				let listdata = []
				this.fullscreenLoading = false

				if (this.tableType) {
					this.studentTotal = res.data.result.total
					allData.map((item, index) => {
						// console.log(item)
						// 获取评分规则
						// this.$post('proportion/get', {
						// 	token: this.$store.state.instructor,
						//   product_id: item.product_id,
						//   shop_id: this.$store.state.store.id
						// }).then(res => {

						// this.proportionList.filter(i => {
						//   if (i.product_id == item.product_id) {
						//     this.proportion = JSON.parse(i.resources)
						//   }
						// })

						// this.proportion = JSON.parse(res.data.result.resources)

						let type = true
						let ratea = []

						try {
							ratea = JSON.parse(item.rate)
						} catch {
							// console.log(item.id)
						}

						if (ratea == null) {
							// console.log('进来了')
							let obja = {}
							// console.log(item)
							obja.idcard = item.idcard
							obja.phone = item.phone
							obja.user_name = item.user_name
							obja.product_name = item.product_name
							obja.company = item.company
							obja.task_name = '-'
							obja.end_date_time = '-'
							obja.start_date_time = item.created_at
							obja.listscore = 0
							obja.state = '未开始'


							listData.push(obja)
							listData.push(obja)
							this.studnetData = listData

						}

						if (ratea != null) {

							// 遍历rate插入数据
							ratea.map((item1, index1) => {
                                // console.log(item1)
								type = true
								let obj = {}
								let score2 = 0
								let listdata = ['1']

								item1.task_activities.map((item2, index2) => {

									// 如果是培训心得的话略过不处理
									if (item2.name == 'exam') {
										type = false
										return false
									} else {
										// 计算每一个活动的分数
										let score1 = 0
										if (item2.resources != null) {

											item2.resources.map((item3, index3) => {
												// 计算每一个活动分类的分数
												//resources
												let score = 0
												//0.222
												if (item3.items != null) {
													// 计算每一个课程的分数
													item3.items.map((item4, index4) => {
														// 判断是否为辅导员评分并且插入相应的数据
														if (item4.rule == 1) {
															// 是辅导员
															//items
															obj = {}
															// 判断课程是否完成
															if (item1.taskState == 1) {

																obj.state = '未完成'
															} else if (item1.taskState == 2) {
																obj.state = '已完成'
															}
															obj.idcard = item.idcard
															obj.phone = item.phone
															obj.user_name = item.user_name
															obj.product_name = item.product_name
															obj.company = item.company
															obj.task_name = item1.task_name
															obj.end_date_time = item.updated_at
															obj.start_date_time = item.created_at

															// 赋予初始值用于算分
															if (item4.grade == undefined) {
																item4.grade = 0
															}


															if (isNaN(score)) {
																if (isNaN(item4.progress)) {
																	item4.progress = 0
																}
																score = item4.progress * item4.grade / 100
																// console.log(score + '=' + item4.progress + '*' + item4.grade + '除以100j加上一个分数')
															} else {
																if (isNaN(item4.progress)) {
																	item4.progress = 0
																}
																score += item4.progress * item4.grade / 100
																// console.log(score + '=' + item4.progress + '*' + item4.grade + '除以100加上一个分数')
															}

														} else {
															// 不是辅导员
															//items
															obj = {}
															// 判断课程是否完成
															if (item1.taskState == 1) {
																obj.state = '未完成'
																obj.end_date_time = '-'
															} else if (item1.taskState == 2) {
																obj.state = '已完成'
																obj.end_date_time = item.updated_at
															}
															obj.idcard = item.idcard
															obj.phone = item.phone
															obj.user_name = item.user_name
															obj.product_name = item.product_name
															obj.company = item.company
															obj.task_name = item1.task_name
															obj.start_date_time = item.created_at
															if (item1.period == undefined) {
																obj.period = ""
															} else {
																obj.period = item1.period
															}

															if (isNaN(score)) {
																if (isNaN(item4.progress)) {
																	item4.progress = 0
																}
																score = item4.progress * item4.percentage / 100
																// console.log(score + '=' + item4.progress + '*' + item4.percentage)
															} else {
																if (isNaN(item4.progress)) {
																	item4.progress = 0
																}
																score += item4.progress * item4.percentage / 100
																// console.log(score + '=' + item4.progress + '*' + item4.percentage + '除以100加上一个score')

															}
														}
													})
													if (isNaN(score2)) {
														score1 = score * item3.percentage / 100
														// console.log('score1：' + score1 + '=' + score + '*' + item3.percentage / 100)
														// console.log('---------------------------------------')
													} else {
														score1 += score * item3.percentage / 100
														// console.log('score1：' + score1 + '=' + score + '*' + item3.percentage / 100 + '加上个score1')
														// console.log('---------------------------------------')
													}

												}


											})
											if (isNaN(score2)) {
												score2 = score1 * item2.percentage
												// console.log('score2:' + score2 + '=' + score1 + '*' + item2.percentage)
												// console.log('------------------score2---------------------')
											} else {
												score2 += score1 * item2.percentage
												// console.log('score2:' + score2 + '=' + score1 + '*' + item2.percentage + '上一个score2')
												//                   console.log('------------------score2---------------------')
											}

										}


									}
								})
								// console.log(score2, 'score')
								// console.log(obj, 'obj')
                                
								if (isNaN(score2)) {
									score2 = 0
									// 已完成的话把分数取正
									if (obj.state == '已完成') {
										obj.listscore = Math.ceil(score2)
										// listdata.push(Math.ceil(score2))
									} else {
										obj.listscore = Math.ceil(score2)
										// listdata.push(score2)
									}

									let ifobj = JSON.stringify(obj)
									// console.log('------------------------------------------一个课程---------------------------------------------------------')

									// 去掉因为判断为主题讨论为空的数组
									if (ifobj != '{"listscore":0}') {
                                        obj.task_id = item1.task_id
										listData.push(obj)
                                        console.log(obj)
									}
								} else {
									// 已完成的话把分数取正
									if (obj.state == '已完成') {
										obj.listscore = Math.ceil(score2)
									} else {
										obj.listscore = Math.ceil(score2)
									}
									let ifobj = JSON.stringify(obj)
									// console.log('------------------------------------------一个课程---------------------------------------------------------')
									// 去掉因为判断为主题讨论为空的数组
									if (ifobj != '{"listscore":0}') {
                                        obj.task_id = item1.task_id
										listData.push(obj)
                                        console.log(obj)
									}
								}


							})
							// console.log(listData)
							this.studnetData = listData

						}



					})

				} else {
					this.studentTotal = res.data.result.total
					allData.map(item => {
						let obj = {}
						obj.discipline = item.discipline
						obj.year = item.year
						obj.learning_period = item.learning_period
						obj.progress = item.progress * 100
						obj.start_date_time = item.created_at
						obj.idcard = item.idcard
						obj.phone = item.phone
						obj.user_name = item.user_name
						obj.product_name = item.product_name
						obj.company = item.company
						if (item.progress != 1) {
							obj.state = '未完成'
							obj.end_date_time = '-'
						} else {
							obj.state = '已完成'
							if (item.end_time) {
								obj.end_date_time = item.end_time
							} else {
								obj.end_date_time = item.updated_at;
							}
						}
						// console.log(obj)
						listData.push(obj)
						// console.log(listData)
					})
					this.studnetData = listData
					// console.log(listData)
				}

				this.fullscreenLoading = false;
			})
		},

		// 获取所有评分规则数组
		getProportionList() {
			// this.fullscreenLoading = true
			this.$post('proportion/get_all', {
				token: this.$store.state.authority_management,
				shop_id: this.$store.state.store.id,
				offset: 0,
				length: 999
			}).then(res => {
				this.proportionList = res.data.result.data
				// console.log(this.proportionList)
				// this.getArrlist()
			})
		}

	},
	created() {
		// this.getdata();
		// 获取所有评分规则
		// this.getProportionList()

		this.getArrlist()
	}
}
